import script from "./ConformitySettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ConformitySettings.vue?vue&type=script&setup=true&lang=js"

import "./ConformitySettings.vue?vue&type=style&index=0&id=97f207d0&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97f207d0"]])

export default __exports__